"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanRule = void 0;
const ModelCommon_1 = require("./ModelCommon");
const debug = !process.env.AWS_SESSION_TOKEN && false;
const typeName = 'BooleanRule';
class BooleanRule extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(typeName, ob);
        this.name = '';
        this.enabled = false;
        this.triggeringValue = false;
        if (ob) {
            const userAttDefs = this.getUserAttributes();
            Object.entries(userAttDefs).forEach(([key, def]) => {
                if (Object.getOwnPropertyDescriptor(def, 'default') && ob[key] === undefined) {
                    this[key] = def.default;
                }
            });
            Object.assign(this, ob);
            debug && console.log('Tried to initialize metric rule', this);
        }
    }
    get deviceEnabledType() {
        return this._deviceEnabledType;
    }
    set deviceEnabledType(type) {
        this._deviceEnabledType = type;
    }
    get key() {
        return this._key;
    }
    set key(metric) {
        this._key = metric;
    }
    isSaveable() {
        return false;
    }
    getUserAttributes() {
        return {
            name: { type: 'String' },
            description: { type: 'String' },
            enabled: { type: 'Boolean', default: false },
            triggeringValue: { type: 'Boolean', default: false },
            key: {
                type: 'String',
                label: 'Measurement',
            },
        };
    }
}
exports.BooleanRule = BooleanRule;
